import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-toolbar gap-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_6 = {
  key: 1,
  class: "bi bi-save me-1"
}
const _hoisted_7 = { class: "card-body pt-0 pb-5" }
const _hoisted_8 = { class: "row align-items-center" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-8 mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex gap-3"
}
const _hoisted_13 = { class: "badge badge-light-primary fs-7" }
const _hoisted_14 = {
  key: 1,
  class: "text-muted fs-7"
}
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-header border-0 pt-0" }
const _hoisted_17 = {
  class: "nav nav-tabs nav-line-tabs nav-line-tabs-2x fs-6 fw-semibold",
  id: "settingsTabs"
}
const _hoisted_18 = { class: "nav-item" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = { class: "nav-item" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "row g-5" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "d-flex gap-4 mb-4" }
const _hoisted_28 = { class: "ms-auto text-end" }
const _hoisted_29 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_30 = { class: "ms-auto text-end" }
const _hoisted_31 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_32 = { class: "d-flex gap-4" }
const _hoisted_33 = { class: "ms-auto" }
const _hoisted_34 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_35 = { class: "ms-auto" }
const _hoisted_36 = {
  key: 0,
  class: "badge badge-info"
}
const _hoisted_37 = { class: "ms-auto" }
const _hoisted_38 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_39 = { class: "ms-auto" }
const _hoisted_40 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "form-label fw-semibold" }
const _hoisted_43 = { class: "badge badge-light-primary ms-2" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "form-label fw-semibold" }
const _hoisted_46 = { class: "badge badge-light-primary ms-2" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = { class: "form-label fw-semibold" }
const _hoisted_49 = { class: "badge badge-light-primary ms-2" }
const _hoisted_50 = { class: "col-12" }
const _hoisted_51 = { class: "mb-0" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-label fw-semibold" }
const _hoisted_54 = { class: "text-muted fs-8 ms-1" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = { class: "form-label fw-semibold" }
const _hoisted_57 = { class: "text-muted fs-8 ms-1" }
const _hoisted_58 = { class: "col-md-6" }
const _hoisted_59 = { class: "form-label fw-semibold" }
const _hoisted_60 = { class: "text-muted fs-8 ms-1" }
const _hoisted_61 = { class: "row g-5" }
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = { class: "form-label fw-semibold" }
const _hoisted_64 = { class: "badge badge-light-primary ms-2" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = { class: "form-label fw-semibold" }
const _hoisted_67 = { class: "badge badge-light-primary ms-2" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-label fw-semibold" }
const _hoisted_70 = { class: "badge badge-light-primary ms-2" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "form-label fw-semibold" }
const _hoisted_73 = { class: "badge badge-light-primary ms-2" }
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "form-label fw-semibold" }
const _hoisted_76 = { class: "badge badge-light-primary ms-2" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "form-check form-switch form-check-custom form-check-solid mt-2" }
const _hoisted_79 = { class: "form-check-label fw-semibold text-gray-700" }
const _hoisted_80 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_81 = { class: "form-label fs-8" }
const _hoisted_82 = { class: "row g-5" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { class: "form-label fw-semibold" }
const _hoisted_85 = { class: "badge badge-light-primary ms-2" }
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "form-label fw-semibold" }
const _hoisted_88 = { class: "badge badge-light-primary ms-2" }
const _hoisted_89 = { class: "col-md-6" }
const _hoisted_90 = { class: "form-label fw-semibold" }
const _hoisted_91 = { class: "badge badge-light-primary ms-2" }
const _hoisted_92 = { class: "col-md-6" }
const _hoisted_93 = { class: "form-label fw-semibold" }
const _hoisted_94 = { class: "badge badge-light-primary ms-2" }
const _hoisted_95 = { class: "col-md-6" }
const _hoisted_96 = { class: "form-label fw-semibold" }
const _hoisted_97 = { class: "badge badge-light-primary ms-2" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-label fw-semibold" }
const _hoisted_100 = { class: "badge badge-light-primary ms-2" }
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = { class: "form-label fw-semibold" }
const _hoisted_103 = { class: "badge badge-light-primary ms-2" }
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "form-label fw-semibold" }
const _hoisted_106 = { class: "badge badge-light-primary ms-2" }
const _hoisted_107 = { class: "form-label fw-semibold fs-8" }
const _hoisted_108 = { class: "badge badge-light-info ms-1" }
const _hoisted_109 = ["onUpdate:modelValue"]
const _hoisted_110 = { class: "col-12" }
const _hoisted_111 = { class: "row g-5" }
const _hoisted_112 = { class: "col-md-6" }
const _hoisted_113 = { class: "form-label fw-semibold" }
const _hoisted_114 = { class: "badge badge-light-primary ms-2" }
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = { class: "form-label fw-semibold" }
const _hoisted_117 = { class: "badge badge-light-primary ms-2" }
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = { class: "form-label fw-semibold" }
const _hoisted_120 = { class: "badge badge-light-primary ms-2" }
const _hoisted_121 = { class: "col-md-6" }
const _hoisted_122 = { class: "form-label fw-semibold" }
const _hoisted_123 = { class: "badge badge-light-primary ms-2" }
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = { class: "form-label fw-semibold" }
const _hoisted_126 = { class: "badge badge-light-primary ms-2" }
const _hoisted_127 = { class: "col-md-6" }
const _hoisted_128 = { class: "form-label fw-semibold" }
const _hoisted_129 = { class: "badge badge-light-primary ms-2" }
const _hoisted_130 = { class: "col-md-6" }
const _hoisted_131 = { class: "form-check form-switch form-check-custom form-check-solid mt-2" }
const _hoisted_132 = { class: "form-check-label fw-semibold text-gray-700" }
const _hoisted_133 = { class: "col-md-6" }
const _hoisted_134 = { class: "form-check form-switch form-check-custom form-check-solid mt-2" }
const _hoisted_135 = { class: "form-check-label fw-semibold text-gray-700" }
const _hoisted_136 = { class: "col-md-4" }
const _hoisted_137 = { class: "form-label fw-semibold fs-8" }
const _hoisted_138 = { class: "badge badge-light-info ms-1" }
const _hoisted_139 = { class: "col-md-4" }
const _hoisted_140 = { class: "form-label fw-semibold fs-8" }
const _hoisted_141 = { class: "badge badge-light-info ms-1" }
const _hoisted_142 = { class: "col-md-4" }
const _hoisted_143 = { class: "form-label fw-semibold fs-8" }
const _hoisted_144 = { class: "badge badge-light-info ms-1" }
const _hoisted_145 = { class: "row g-5" }
const _hoisted_146 = { class: "col-md-6" }
const _hoisted_147 = { class: "form-label fw-semibold" }
const _hoisted_148 = { class: "badge badge-light-primary ms-2" }
const _hoisted_149 = { class: "col-md-6" }
const _hoisted_150 = { class: "form-label fw-semibold" }
const _hoisted_151 = { class: "badge badge-light-primary ms-2" }
const _hoisted_152 = { class: "col-md-6" }
const _hoisted_153 = { class: "form-label fw-semibold" }
const _hoisted_154 = { class: "badge badge-light-primary ms-2" }
const _hoisted_155 = { class: "col-md-6" }
const _hoisted_156 = { class: "form-label fw-semibold" }
const _hoisted_157 = { class: "badge badge-light-primary ms-2" }
const _hoisted_158 = { class: "col-md-6" }
const _hoisted_159 = { class: "form-label fw-semibold" }
const _hoisted_160 = { class: "badge badge-light-primary ms-2" }
const _hoisted_161 = { class: "col-md-4" }
const _hoisted_162 = { class: "form-label fw-semibold" }
const _hoisted_163 = { class: "badge badge-light-primary ms-2" }
const _hoisted_164 = { class: "col-md-4" }
const _hoisted_165 = { class: "form-label fw-semibold" }
const _hoisted_166 = { class: "badge badge-light-primary ms-2" }
const _hoisted_167 = { class: "col-md-4" }
const _hoisted_168 = { class: "form-label fw-semibold" }
const _hoisted_169 = { class: "badge badge-light-primary ms-2" }
const _hoisted_170 = { class: "col-md-6" }
const _hoisted_171 = { class: "form-check form-switch form-check-custom form-check-solid mt-2" }
const _hoisted_172 = { class: "form-check-label fw-semibold text-gray-700" }
const _hoisted_173 = { class: "col-md-6" }
const _hoisted_174 = { class: "form-label fw-semibold" }
const _hoisted_175 = { class: "badge badge-light-primary ms-2" }
const _hoisted_176 = { class: "row g-5" }
const _hoisted_177 = { class: "col-md-6" }
const _hoisted_178 = { class: "col-md-6" }
const _hoisted_179 = { class: "form-label fw-semibold" }
const _hoisted_180 = { class: "badge badge-light-primary ms-2" }
const _hoisted_181 = { class: "col-md-6" }
const _hoisted_182 = { class: "form-label fw-semibold" }
const _hoisted_183 = { class: "badge badge-light-primary ms-2" }
const _hoisted_184 = { class: "col-md-6" }
const _hoisted_185 = { class: "form-label fw-semibold" }
const _hoisted_186 = { class: "badge badge-light-primary ms-2" }
const _hoisted_187 = { class: "col-md-6" }
const _hoisted_188 = { class: "form-label fw-semibold" }
const _hoisted_189 = { class: "badge badge-light-primary ms-2" }
const _hoisted_190 = { class: "col-md-6" }
const _hoisted_191 = { class: "form-label fw-semibold" }
const _hoisted_192 = { class: "badge badge-light-primary ms-2" }
const _hoisted_193 = { class: "col-md-6" }
const _hoisted_194 = { class: "form-label fw-semibold" }
const _hoisted_195 = { class: "badge badge-light-primary ms-2" }
const _hoisted_196 = { class: "col-md-6" }
const _hoisted_197 = { class: "form-label fw-semibold" }
const _hoisted_198 = { class: "badge badge-light-primary ms-2" }
const _hoisted_199 = {
  key: 0,
  class: "position-fixed bottom-0 end-0 p-3",
  style: {"z-index":"9999"}
}
const _hoisted_200 = {
  key: 1,
  class: "position-fixed bottom-0 end-0 p-3",
  style: {"z-index":"9999"}
}
const _hoisted_201 = { class: "toast show align-items-center text-white bg-danger border-0" }
const _hoisted_202 = { class: "d-flex" }
const _hoisted_203 = { class: "toast-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[69] || (_cache[69] = _createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
          _createElementVNode("span", { class: "card-label fw-bold fs-3 mb-1" }, "Pengaturan IoT Camera"),
          _createElementVNode("span", { class: "text-muted mt-1 fw-semibold fs-7" }, " Konfigurasi model deteksi dan parameter preprocessing per perangkat ")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportConfig && _ctx.exportConfig(...args))),
            class: "btn btn-sm btn-light-info"
          }, [...(_cache[67] || (_cache[67] = [
            _createElementVNode("i", { class: "bi bi-download me-1" }, null, -1),
            _createTextVNode(" Export config.json ", -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetToDefault && _ctx.resetToDefault(...args))),
            class: "btn btn-sm btn-light-warning"
          }, [...(_cache[68] || (_cache[68] = [
            _createElementVNode("i", { class: "bi bi-arrow-counterclockwise me-1" }, null, -1),
            _createTextVNode(" Reset Default ", -1)
          ]))]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args))),
            class: "btn btn-sm btn-primary",
            disabled: _ctx.saving
          }, [
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5))
              : (_openBlock(), _createElementBlock("i", _hoisted_6)),
            _createTextVNode(" " + _toDisplayString(_ctx.saving ? 'Menyimpan...' : 'Simpan'), 1)
          ], 8, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[71] || (_cache[71] = _createElementVNode("label", { class: "form-label fw-bold" }, "Pilih Perangkat", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDeviceId) = $event)),
              class: "form-select",
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDeviceChange && _ctx.onDeviceChange(...args)))
            }, [
              _cache[70] || (_cache[70] = _createElementVNode("option", { value: "global" }, "Global (Semua Perangkat)", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: device.id,
                  value: device.id
                }, " #" + _toDisplayString(device.id) + " — " + _toDisplayString(device.name || 'Unnamed') + " " + _toDisplayString(device.location ? '· ' + device.location : ''), 9, _hoisted_10))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.selectedDeviceId]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.selectedDeviceId !== 'global')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _cache[72] || (_cache[72] = _createElementVNode("i", { class: "bi bi-cpu me-1" }, null, -1)),
                    _createTextVNode("ID: " + _toDisplayString(_ctx.selectedDeviceId), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(`badge badge-light-${_ctx.currentModel === 'smart_motion' || _ctx.currentModel === 'smart_cascade' ? 'primary' : _ctx.currentModel === 'contour' ? 'warning' : _ctx.currentModel === 'contour_motion' ? 'danger' : _ctx.currentModel === 'yolo11n_coco' ? 'info' : 'success'} fs-7`)
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`bi bi-${_ctx.currentModel === 'smart_motion' || _ctx.currentModel === 'smart_cascade' ? 'stars' : _ctx.currentModel === 'contour' || _ctx.currentModel === 'contour_motion' ? 'layers' : 'robot'} me-1`)
                    }, null, 2),
                    _createTextVNode(" Model: " + _toDisplayString(_ctx.currentModel === 'smart_motion' ? 'Walet Cerdas' : _ctx.currentModel === 'smart_cascade' ? 'Walet Cerdas AI' : _ctx.currentModel === 'yolov8n' ? 'YOLOv8n' : _ctx.currentModel === 'yolo11n_coco' ? 'YOLO11n COCO' : _ctx.currentModel === 'contour_motion' ? 'Contour Motion' : 'Contour Tradisional'), 1)
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[73] || (_cache[73] = [
                  _createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1),
                  _createTextVNode(" Pengaturan global akan digunakan oleh semua perangkat yang tidak memiliki konfigurasi khusus. ", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("ul", _hoisted_17, [
          _createElementVNode("li", _hoisted_18, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'model' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'model')),
              href: "#"
            }, [...(_cache[74] || (_cache[74] = [
              _createElementVNode("i", { class: "bi bi-robot me-1" }, null, -1),
              _createTextVNode(" Model ", -1)
            ]))], 2)
          ]),
          _createElementVNode("li", _hoisted_19, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'preprocessing' }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeTab = 'preprocessing')),
              href: "#"
            }, [...(_cache[75] || (_cache[75] = [
              _createElementVNode("i", { class: "bi bi-sliders me-1" }, null, -1),
              _createTextVNode(" Preprocessing Warna ", -1)
            ]))], 2)
          ]),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'detection' }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.activeTab = 'detection')),
              href: "#"
            }, [...(_cache[76] || (_cache[76] = [
              _createElementVNode("i", { class: "bi bi-bounding-box me-1" }, null, -1),
              _createTextVNode(" Deteksi ", -1)
            ]))], 2)
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'tracker' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.activeTab = 'tracker')),
              href: "#"
            }, [...(_cache[77] || (_cache[77] = [
              _createElementVNode("i", { class: "bi bi-arrows-move me-1" }, null, -1),
              _createTextVNode(" Tracker ", -1)
            ]))], 2)
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'counting' }]),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.activeTab = 'counting')),
              href: "#"
            }, [...(_cache[78] || (_cache[78] = [
              _createElementVNode("i", { class: "bi bi-123 me-1" }, null, -1),
              _createTextVNode(" Counting ", -1)
            ]))], 2)
          ]),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("a", {
              class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'background' }]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.activeTab = 'background')),
              href: "#"
            }, [...(_cache[79] || (_cache[79] = [
              _createElementVNode("i", { class: "bi bi-layers me-1" }, null, -1),
              _createTextVNode(" Background ", -1)
            ]))], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[95] || (_cache[95] = _createStaticVNode("<div class=\"notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-5\"><i class=\"bi bi-info-circle fs-2tx text-primary me-4\"></i><div><h5 class=\"mb-1\">Pilih Model Deteksi</h5><p class=\"mb-0 fs-7 text-gray-600\"><b>Walet Cerdas</b> (disarankan): Deteksi gerak + filter bentuk &amp; ukuran + validasi lintasan, sehingga fokus menghitung burung walet secara akurat. Ringan dan hemat sumber daya (berjalan tanpa GPU).<br><b>Walet Cerdas AI</b>: Walet Cerdas + verifikasi AI per-objek (model ONNX kecil). Akurasi tertinggi.<br><b>YOLOv8n</b>: Model deep learning terlatih pada dataset walet (mAP50=90.7%). Paling akurat untuk walet.<br><b>YOLO11n COCO</b>: Model umum deteksi burung dari dataset COCO. Untuk benchmarking — bandingkan performa vs model khusus walet.<br><b>Contour Tradisional</b>: MOG2 background subtraction + analisis kontur + validasi bentuk (solidity, aspect ratio, dll).<br><b>Contour Motion</b>: Khusus burung walet berukuran kecil — sangat sensitif mendeteksi setiap titik gerak. Cocok jika walet tampak sebagai titik kecil hitam/putih di kamera. </p></div></div>", 1)),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.currentModel = 'smart_motion')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'smart_motion' ? 'border-primary bg-light-primary' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'smart_motion' ? 'bg-primary' : 'bg-secondary'}`)
                  }, [...(_cache[80] || (_cache[80] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-stars text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[82] || (_cache[82] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "Walet Cerdas"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "Gerak + Bentuk + Ukuran · Ringan, tanpa GPU"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Fokus menghitung burung walet")
                  ], -1)),
                  _createElementVNode("div", _hoisted_28, [
                    (_ctx.currentModel === 'smart_motion')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Aktif"))
                      : _createCommentVNode("", true),
                    _cache[81] || (_cache[81] = _createElementVNode("span", { class: "badge badge-light-primary ms-1 fs-9" }, "Disarankan", -1))
                  ])
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.currentModel = 'smart_cascade')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'smart_cascade' ? 'border-primary bg-light-primary' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'smart_cascade' ? 'bg-primary' : 'bg-secondary'}`)
                  }, [...(_cache[83] || (_cache[83] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-robot text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[85] || (_cache[85] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "Walet Cerdas AI"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "Cascade + verifikasi AI per-objek"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Model: swiftlet_patch_clf.onnx")
                  ], -1)),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.currentModel === 'smart_cascade')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Aktif"))
                      : _createCommentVNode("", true),
                    _cache[84] || (_cache[84] = _createElementVNode("span", { class: "badge badge-light-info ms-1 fs-9" }, "AI", -1))
                  ])
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentModel = 'yolov8n')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'yolov8n' ? 'border-success bg-light-success' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'yolov8n' ? 'bg-success' : 'bg-secondary'}`)
                  }, [...(_cache[86] || (_cache[86] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-robot text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[87] || (_cache[87] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "YOLOv8n"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "Deep Learning · mAP50: 90.7%"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Model: swiftlet_yolov8n.onnx")
                  ], -1)),
                  _createElementVNode("div", _hoisted_33, [
                    (_ctx.currentModel === 'yolov8n')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Aktif"))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentModel = 'yolo11n_coco')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'yolo11n_coco' ? 'border-info bg-light-info' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'yolo11n_coco' ? 'bg-info' : 'bg-secondary'}`)
                  }, [...(_cache[88] || (_cache[88] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-cpu text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[90] || (_cache[90] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "YOLO11n COCO"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "Deep Learning · General Bird (COCO)"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Model: yolo11n_bird.onnx")
                  ], -1)),
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.currentModel === 'yolo11n_coco')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Aktif"))
                      : _createCommentVNode("", true),
                    _cache[89] || (_cache[89] = _createElementVNode("span", { class: "badge badge-light-secondary ms-1 fs-9" }, "Benchmark", -1))
                  ])
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.currentModel = 'contour')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'contour' ? 'border-warning bg-light-warning' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'contour' ? 'bg-warning' : 'bg-secondary'}`)
                  }, [...(_cache[91] || (_cache[91] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-layers text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[92] || (_cache[92] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "Contour Tradisional"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "MOG2 + OpenCV · Ringan"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Tidak memerlukan ONNX model")
                  ], -1)),
                  _createElementVNode("div", _hoisted_37, [
                    (_ctx.currentModel === 'contour')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Aktif"))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.currentModel = 'contour_motion')),
                  class: _normalizeClass(`card card-bordered cursor-pointer flex-row align-items-center p-5 gap-4 flex-1 ${_ctx.currentModel === 'contour_motion' ? 'border-danger bg-light-danger' : 'border-gray-300'}`),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`symbol symbol-50px symbol-circle ${_ctx.currentModel === 'contour_motion' ? 'bg-danger' : 'bg-secondary'}`)
                  }, [...(_cache[93] || (_cache[93] = [
                    _createElementVNode("span", { class: "symbol-label text-white fs-3" }, [
                      _createElementVNode("i", { class: "bi bi-wind text-white" })
                    ], -1)
                  ]))], 2),
                  _cache[94] || (_cache[94] = _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "fw-bold fs-5" }, "Contour Motion"),
                    _createElementVNode("div", { class: "text-gray-500 fs-7" }, "Motion + Blob · Paling Sensitif"),
                    _createElementVNode("div", { class: "text-gray-400 fs-8" }, "Sangat sensitif untuk walet berukuran titik kecil")
                  ], -1)),
                  _createElementVNode("div", _hoisted_39, [
                    (_ctx.currentModel === 'contour_motion')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Aktif"))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ])
            ]),
            (_ctx.currentModel === 'contour_motion')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[102] || (_cache[102] = _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("div", { class: "separator separator-dashed my-2" }),
                    _createElementVNode("h5", { class: "mb-0" }, "Parameter Contour Motion")
                  ], -1)),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, [
                      _cache[96] || (_cache[96] = _createTextVNode("Area Minimum Blob (px²) ", -1)),
                      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.config.cm_min_area), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "5",
                      max: "100",
                      step: "1",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.config.cm_min_area) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.cm_min_area,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[97] || (_cache[97] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                      _createElementVNode("span", null, "5 (sangat kecil)"),
                      _createElementVNode("span", null, "100 (medium)")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, [
                      _cache[98] || (_cache[98] = _createTextVNode("Area Maksimum Blob (px²) ", -1)),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.config.cm_max_area), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "100",
                      max: "3000",
                      step: "50",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.config.cm_max_area) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.cm_max_area,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[99] || (_cache[99] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                      _createElementVNode("span", null, "100"),
                      _createElementVNode("span", null, "3000 (besar)")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, [
                      _cache[100] || (_cache[100] = _createTextVNode("Frame Diff Threshold ", -1)),
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.config.cm_diff_threshold), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "5",
                      max: "60",
                      step: "1",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.config.cm_diff_threshold) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.cm_diff_threshold,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[101] || (_cache[101] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                      _createElementVNode("span", null, "5 (sensitif)"),
                      _createElementVNode("span", null, "60 (ketat)")
                    ], -1))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.currentModel === 'yolov8n' || _ctx.currentModel === 'yolo11n_coco')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[103] || (_cache[103] = _createElementVNode("div", { class: "separator separator-dashed my-2" }, null, -1)),
                    _createElementVNode("h5", _hoisted_51, "Parameter YOLO " + _toDisplayString(_ctx.currentModel === 'yolo11n_coco' ? '(YOLO11n COCO)' : '(YOLOv8n)'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("label", _hoisted_53, [
                      _cache[104] || (_cache[104] = _createTextVNode("Confidence Threshold YOLO ", -1)),
                      _createElementVNode("span", _hoisted_54, "(" + _toDisplayString(_ctx.config.yolo_conf_threshold) + ")", 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "0.1",
                      max: "0.9",
                      step: "0.05",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.config.yolo_conf_threshold) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.yolo_conf_threshold,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[105] || (_cache[105] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                      _createElementVNode("span", null, "0.1 (sensitif)"),
                      _createElementVNode("span", null, "0.9 (ketat)")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, [
                      _cache[106] || (_cache[106] = _createTextVNode("NMS IoU Threshold YOLO ", -1)),
                      _createElementVNode("span", _hoisted_57, "(" + _toDisplayString(_ctx.config.yolo_nms_threshold) + ")", 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "0.1",
                      max: "0.9",
                      step: "0.05",
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.config.yolo_nms_threshold) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.yolo_nms_threshold,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[107] || (_cache[107] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                      _createElementVNode("span", null, "0.1 (strict)"),
                      _createElementVNode("span", null, "0.9 (relaxed)")
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("label", _hoisted_59, [
                      _cache[108] || (_cache[108] = _createTextVNode("Input Size YOLO (px) ", -1)),
                      _createElementVNode("span", _hoisted_60, "(" + _toDisplayString(_ctx.config.yolo_input_size) + ")", 1)
                    ]),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.config.yolo_input_size) = $event)),
                      class: "form-select"
                    }, [...(_cache[109] || (_cache[109] = [
                      _createElementVNode("option", { value: 320 }, "320 × 320 (cepat)", -1),
                      _createElementVNode("option", { value: 416 }, "416 × 416", -1),
                      _createElementVNode("option", { value: 640 }, "640 × 640 (akurat)", -1)
                    ]))], 512), [
                      [
                        _vModelSelect,
                        _ctx.config.yolo_input_size,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'model']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _cache[126] || (_cache[126] = _createElementVNode("div", { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-6" }, [
            _createElementVNode("i", { class: "bi bi-palette fs-2tx text-warning me-4" }),
            _createElementVNode("div", null, [
              _createElementVNode("h5", { class: "mb-1" }, "Preprocessing Warna"),
              _createElementVNode("p", { class: "mb-0 fs-7 text-gray-600" }, " Penyesuaian warna sebelum deteksi. Berguna di kondisi pencahayaan tidak ideal (gelap, terlalu terang, atau kamera berwarna berbeda). Nilai 0 = tidak ada perubahan. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("label", _hoisted_63, [
                _cache[110] || (_cache[110] = _createElementVNode("i", { class: "bi bi-sun me-1" }, null, -1)),
                _cache[111] || (_cache[111] = _createTextVNode(" Brightness (Kecerahan) ", -1)),
                _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.config.color_brightness > 0 ? '+' : '') + _toDisplayString(_ctx.config.color_brightness), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "-100",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.config.color_brightness) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.color_brightness,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[112] || (_cache[112] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "-100 (gelap)"),
                _createElementVNode("span", null, "0"),
                _createElementVNode("span", null, "+100 (terang)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("label", _hoisted_66, [
                _cache[113] || (_cache[113] = _createElementVNode("i", { class: "bi bi-circle-half me-1" }, null, -1)),
                _cache[114] || (_cache[114] = _createTextVNode(" Contrast (Kontras) ", -1)),
                _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.config.color_contrast > 0 ? '+' : '') + _toDisplayString(_ctx.config.color_contrast) + "%", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "-100",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.config.color_contrast) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.color_contrast,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[115] || (_cache[115] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "-100 (flat)"),
                _createElementVNode("span", null, "0"),
                _createElementVNode("span", null, "+100 (tinggi)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("label", _hoisted_69, [
                _cache[116] || (_cache[116] = _createElementVNode("i", { class: "bi bi-droplet-half me-1" }, null, -1)),
                _cache[117] || (_cache[117] = _createTextVNode(" Saturation (Saturasi) ", -1)),
                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.config.color_saturation > 0 ? '+' : '') + _toDisplayString(_ctx.config.color_saturation) + "%", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "-100",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.config.color_saturation) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.color_saturation,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[118] || (_cache[118] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "-100 (grayscale)"),
                _createElementVNode("span", null, "0"),
                _createElementVNode("span", null, "+100 (vivid)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("label", _hoisted_72, [
                _cache[119] || (_cache[119] = _createElementVNode("i", { class: "bi bi-palette me-1" }, null, -1)),
                _cache[120] || (_cache[120] = _createTextVNode(" Hue Shift (Geser Warna) ", -1)),
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.config.color_hue > 0 ? '+' : '') + _toDisplayString(_ctx.config.color_hue) + "°", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "-180",
                max: "180",
                step: "10",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.config.color_hue) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.color_hue,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[121] || (_cache[121] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "-180°"),
                _createElementVNode("span", null, "0°"),
                _createElementVNode("span", null, "+180°")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("label", _hoisted_75, [
                _cache[122] || (_cache[122] = _createElementVNode("i", { class: "bi bi-shadows me-1" }, null, -1)),
                _cache[123] || (_cache[123] = _createTextVNode(" Gamma Correction ", -1)),
                _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.config.color_gamma), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.3",
                max: "3.0",
                step: "0.1",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.config.color_gamma) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.color_gamma,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[124] || (_cache[124] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "0.3 (gelap)"),
                _createElementVNode("span", null, "1.0 (normal)"),
                _createElementVNode("span", null, "3.0 (terang)")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_77, [
              _cache[125] || (_cache[125] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                _createElementVNode("i", { class: "bi bi-symmetry-horizontal me-1" }),
                _createTextVNode(" Clahe (Adaptive Equalization) ")
              ], -1)),
              _createElementVNode("div", _hoisted_78, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.config.color_use_clahe) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.config.color_use_clahe]
                ]),
                _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.config.color_use_clahe ? 'Aktif — meningkatkan kontras lokal' : 'Nonaktif'), 1)
              ]),
              (_ctx.config.color_use_clahe)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("label", _hoisted_81, "Clip Limit: " + _toDisplayString(_ctx.config.color_clahe_clip), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "1",
                      max: "10",
                      step: "0.5",
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.config.color_clahe_clip) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.color_clahe_clip,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'preprocessing']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_82, [
            _cache[142] || (_cache[142] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Ukuran Kontur")
            ], -1)),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("label", _hoisted_84, [
                _cache[127] || (_cache[127] = _createTextVNode("Min Contour Area (px²) ", -1)),
                _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.config.min_contour_area), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "20",
                max: "1000",
                step: "10",
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.config.min_contour_area) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.min_contour_area,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[128] || (_cache[128] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "20"),
                _createElementVNode("span", null, "1000")
              ], -1)),
              _cache[129] || (_cache[129] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Objek lebih kecil dari ini diabaikan. Turunkan jika burung terlewat.", -1))
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("label", _hoisted_87, [
                _cache[130] || (_cache[130] = _createTextVNode("Max Contour Area (px²) ", -1)),
                _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.config.max_contour_area), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1000",
                max: "30000",
                step: "500",
                "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.config.max_contour_area) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.max_contour_area,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[131] || (_cache[131] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "1000"),
                _createElementVNode("span", null, "30000")
              ], -1)),
              _cache[132] || (_cache[132] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Objek lebih besar dari ini diabaikan. Naikkan jika burung besar terlewat.", -1))
            ]),
            _cache[143] || (_cache[143] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "separator separator-dashed my-2" }),
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Bentuk & Aspek Rasio")
            ], -1)),
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("label", _hoisted_90, [
                _cache[133] || (_cache[133] = _createTextVNode("Aspect Ratio Min ", -1)),
                _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.config.shape_aspect_min), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "1.0",
                step: "0.05",
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.config.shape_aspect_min) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.shape_aspect_min,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[134] || (_cache[134] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "0.1"),
                _createElementVNode("span", null, "1.0")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_92, [
              _createElementVNode("label", _hoisted_93, [
                _cache[135] || (_cache[135] = _createTextVNode("Aspect Ratio Max ", -1)),
                _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.config.shape_aspect_max), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1.0",
                max: "6.0",
                step: "0.1",
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.config.shape_aspect_max) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.shape_aspect_max,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[136] || (_cache[136] = _createElementVNode("div", { class: "d-flex justify-content-between text-muted fs-8" }, [
                _createElementVNode("span", null, "1.0"),
                _createElementVNode("span", null, "6.0")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("label", _hoisted_96, [
                _cache[137] || (_cache[137] = _createTextVNode("Min Solidity ", -1)),
                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.config.shape_min_solidity), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "0.9",
                step: "0.05",
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.config.shape_min_solidity) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.shape_min_solidity,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_98, [
              _createElementVNode("label", _hoisted_99, [
                _cache[138] || (_cache[138] = _createTextVNode("Min Compactness ", -1)),
                _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.config.shape_min_compactness), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.01",
                max: "0.5",
                step: "0.01",
                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.config.shape_min_compactness) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.shape_min_compactness,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _cache[144] || (_cache[144] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "separator separator-dashed my-2" }),
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Confidence Scoring")
            ], -1)),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("label", _hoisted_102, [
                _cache[139] || (_cache[139] = _createTextVNode("Confidence Threshold ", -1)),
                _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.config.confidence_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "0.9",
                step: "0.05",
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.config.confidence_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.confidence_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("label", _hoisted_105, [
                _cache[140] || (_cache[140] = _createTextVNode("Display Confidence Threshold ", -1)),
                _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.config.display_confidence_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "0.9",
                step: "0.05",
                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.config.display_confidence_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.display_confidence_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _cache[145] || (_cache[145] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "separator separator-dashed my-2" }),
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Bobot Confidence (harus total = 1.0)")
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confidenceWeights, (label, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-4",
                key: key
              }, [
                _createElementVNode("label", _hoisted_107, [
                  _createTextVNode(_toDisplayString(label) + " ", 1),
                  _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.config[key]), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "range",
                  class: "form-range",
                  min: "0",
                  max: "0.5",
                  step: "0.05",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.config[key]) = $event)
                }, null, 8, _hoisted_109), [
                  [
                    _vModelText,
                    _ctx.config[key],
                    void 0,
                    { number: true }
                  ]
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", {
                class: _normalizeClass(`alert alert-${Math.abs(_ctx.totalConfidenceWeight - 1.0) < 0.01 ? 'success' : 'warning'} py-2 fs-8`)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(`bi bi-${Math.abs(_ctx.totalConfidenceWeight - 1.0) < 0.01 ? 'check-circle' : 'exclamation-triangle'} me-1`)
                }, null, 2),
                _cache[141] || (_cache[141] = _createTextVNode(" Total bobot: ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.totalConfidenceWeight.toFixed(2)), 1),
                _createTextVNode(" " + _toDisplayString(Math.abs(_ctx.totalConfidenceWeight - 1.0) < 0.01 ? '✓ Valid' : '⚠ Harus = 1.0'), 1)
              ], 2)
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'detection']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("label", _hoisted_113, [
                _cache[146] || (_cache[146] = _createTextVNode("Max Distance (px) ", -1)),
                _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.config.tracker_max_distance), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "20",
                max: "300",
                step: "5",
                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.config.tracker_max_distance) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_max_distance,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[147] || (_cache[147] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Jarak maksimum antar frame untuk menganggap objek sama.", -1))
            ]),
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("label", _hoisted_116, [
                _cache[148] || (_cache[148] = _createTextVNode("Max Lost Frames ", -1)),
                _createElementVNode("span", _hoisted_117, _toDisplayString(_ctx.config.tracker_max_lost_frames), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "30",
                step: "1",
                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.config.tracker_max_lost_frames) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_max_lost_frames,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[149] || (_cache[149] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Frame hilang sebelum track dihapus.", -1))
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("label", _hoisted_119, [
                _cache[150] || (_cache[150] = _createTextVNode("Velocity Damping ", -1)),
                _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.config.tracker_velocity_damping), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "1.0",
                step: "0.05",
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.config.tracker_velocity_damping) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_velocity_damping,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[151] || (_cache[151] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Faktor peluruhan kecepatan (1.0 = tidak meluruh).", -1))
            ]),
            _createElementVNode("div", _hoisted_121, [
              _createElementVNode("label", _hoisted_122, [
                _cache[152] || (_cache[152] = _createTextVNode("Distance Growth Factor ", -1)),
                _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.config.tracker_distance_growth), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0",
                max: "1.0",
                step: "0.05",
                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.config.tracker_distance_growth) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_distance_growth,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("label", _hoisted_125, [
                _cache[153] || (_cache[153] = _createTextVNode("Max Distance Cap (px) ", -1)),
                _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.config.tracker_max_distance_cap), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "50",
                max: "500",
                step: "10",
                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.config.tracker_max_distance_cap) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_max_distance_cap,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("label", _hoisted_128, [
                _cache[154] || (_cache[154] = _createTextVNode("BBox Smooth Alpha ", -1)),
                _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.config.bbox_smooth_alpha), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "1.0",
                step: "0.05",
                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.config.bbox_smooth_alpha) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.bbox_smooth_alpha,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[155] || (_cache[155] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Faktor EMA untuk smoothing bounding box (1.0 = tanpa smooth).", -1))
            ]),
            _cache[161] || (_cache[161] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "separator separator-dashed my-2" })
            ], -1)),
            _createElementVNode("div", _hoisted_130, [
              _cache[156] || (_cache[156] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Kalman Filter", -1)),
              _createElementVNode("div", _hoisted_131, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.config.use_kalman_filter) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.config.use_kalman_filter]
                ]),
                _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.config.use_kalman_filter ? 'Aktif' : 'Nonaktif'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_133, [
              _cache[157] || (_cache[157] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Tracker Prediction", -1)),
              _createElementVNode("div", _hoisted_134, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.config.use_tracker_prediction) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.config.use_tracker_prediction]
                ]),
                _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.config.use_tracker_prediction ? 'Aktif' : 'Nonaktif'), 1)
              ])
            ]),
            (_ctx.config.use_kalman_filter)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_136, [
                    _createElementVNode("label", _hoisted_137, [
                      _cache[158] || (_cache[158] = _createTextVNode("Kalman Process Noise Pos ", -1)),
                      _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.config.kalman_process_noise_pos), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "0.1",
                      max: "10",
                      step: "0.1",
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.config.kalman_process_noise_pos) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.kalman_process_noise_pos,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    _createElementVNode("label", _hoisted_140, [
                      _cache[159] || (_cache[159] = _createTextVNode("Kalman Process Noise Vel ", -1)),
                      _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.config.kalman_process_noise_vel), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "0.1",
                      max: "20",
                      step: "0.5",
                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.config.kalman_process_noise_vel) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.kalman_process_noise_vel,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("label", _hoisted_143, [
                      _cache[160] || (_cache[160] = _createTextVNode("Kalman Measurement Noise ", -1)),
                      _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.config.kalman_measurement_noise), 1)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "form-range",
                      min: "0.1",
                      max: "20",
                      step: "0.5",
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.config.kalman_measurement_noise) = $event))
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.config.kalman_measurement_noise,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'tracker']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_145, [
            _cache[176] || (_cache[176] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Gate & Threshold")
            ], -1)),
            _createElementVNode("div", _hoisted_146, [
              _createElementVNode("label", _hoisted_147, [
                _cache[162] || (_cache[162] = _createTextVNode("Center Gate Margin Ratio ", -1)),
                _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.config.center_gate_margin_ratio), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.05",
                max: "0.4",
                step: "0.01",
                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.config.center_gate_margin_ratio) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.center_gate_margin_ratio,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[163] || (_cache[163] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Proporsi lebar frame untuk zona deteksi gate tengah.", -1))
            ]),
            _createElementVNode("div", _hoisted_149, [
              _createElementVNode("label", _hoisted_150, [
                _cache[164] || (_cache[164] = _createTextVNode("Counting Confidence Threshold ", -1)),
                _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.config.counting_confidence_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "0.9",
                step: "0.05",
                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.config.counting_confidence_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.counting_confidence_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_152, [
              _createElementVNode("label", _hoisted_153, [
                _cache[165] || (_cache[165] = _createTextVNode("Min Displacement (px) ", -1)),
                _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.config.counting_min_displacement_px), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "50",
                step: "1",
                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.config.counting_min_displacement_px) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.counting_min_displacement_px,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[166] || (_cache[166] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Pergerakan minimum yang dihitung sebagai hitungan valid.", -1))
            ]),
            _createElementVNode("div", _hoisted_155, [
              _createElementVNode("label", _hoisted_156, [
                _cache[167] || (_cache[167] = _createTextVNode("Cooldown per Track (detik) ", -1)),
                _createElementVNode("span", _hoisted_157, _toDisplayString(_ctx.config.tracker_count_cooldown_seconds) + "s", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "5",
                step: "0.1",
                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.config.tracker_count_cooldown_seconds) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.tracker_count_cooldown_seconds,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("label", _hoisted_159, [
                _cache[168] || (_cache[168] = _createTextVNode("Global Count Min Interval (detik) ", -1)),
                _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.config.global_count_min_interval_seconds) + "s", 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.01",
                max: "1",
                step: "0.01",
                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.config.global_count_min_interval_seconds) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.global_count_min_interval_seconds,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _cache[177] || (_cache[177] = _createElementVNode("div", { class: "col-12" }, [
              _createElementVNode("div", { class: "separator separator-dashed my-2" }),
              _createElementVNode("h6", { class: "text-muted fw-semibold text-uppercase fs-8 mb-0" }, "Temporal Vote Pool")
            ], -1)),
            _createElementVNode("div", _hoisted_161, [
              _createElementVNode("label", _hoisted_162, [
                _cache[169] || (_cache[169] = _createTextVNode("Pending Vote Frames (min hit) ", -1)),
                _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.config.pending_vote_frames), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "5",
                step: "1",
                "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.config.pending_vote_frames) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.pending_vote_frames,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[170] || (_cache[170] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Minimal deteksi dalam window untuk dianggap valid.", -1))
            ]),
            _createElementVNode("div", _hoisted_164, [
              _createElementVNode("label", _hoisted_165, [
                _cache[171] || (_cache[171] = _createTextVNode("Pending Vote Window (frame) ", -1)),
                _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.config.pending_vote_window), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "2",
                max: "10",
                step: "1",
                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.config.pending_vote_window) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.pending_vote_window,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[172] || (_cache[172] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Ukuran jendela vote (frame). Lebih kecil = lebih responsif.", -1))
            ]),
            _createElementVNode("div", _hoisted_167, [
              _createElementVNode("label", _hoisted_168, [
                _cache[173] || (_cache[173] = _createTextVNode("Pending Max Distance (px) ", -1)),
                _createElementVNode("span", _hoisted_169, _toDisplayString(_ctx.config.pending_max_distance), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "5",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.config.pending_max_distance) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.pending_max_distance,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_170, [
              _cache[174] || (_cache[174] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Count Allow Prediction", -1)),
              _createElementVNode("div", _hoisted_171, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.config.count_allow_prediction) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.config.count_allow_prediction]
                ]),
                _createElementVNode("label", _hoisted_172, _toDisplayString(_ctx.config.count_allow_prediction ? 'Aktif' : 'Nonaktif'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_173, [
              _createElementVNode("label", _hoisted_174, [
                _cache[175] || (_cache[175] = _createTextVNode("Relaxed Confidence Threshold ", -1)),
                _createElementVNode("span", _hoisted_175, _toDisplayString(_ctx.config.count_relaxed_confidence_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.1",
                max: "0.9",
                step: "0.05",
                "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.config.count_relaxed_confidence_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.count_relaxed_confidence_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'counting']
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_176, [
            _createElementVNode("div", _hoisted_177, [
              _cache[179] || (_cache[179] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Background Subtractor Type", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.config.bg_subtractor_type) = $event)),
                class: "form-select"
              }, [...(_cache[178] || (_cache[178] = [
                _createElementVNode("option", { value: "MOG2" }, "MOG2 (Mixture of Gaussians v2)", -1),
                _createElementVNode("option", { value: "KNN" }, "KNN (K-Nearest Neighbours)", -1)
              ]))], 512), [
                [_vModelSelect, _ctx.config.bg_subtractor_type]
              ])
            ]),
            _createElementVNode("div", _hoisted_178, [
              _createElementVNode("label", _hoisted_179, [
                _cache[180] || (_cache[180] = _createTextVNode("Learning Rate ", -1)),
                _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.config.bg_learning_rate), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.0001",
                max: "0.01",
                step: "0.0001",
                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.config.bg_learning_rate) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.bg_learning_rate,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[181] || (_cache[181] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Kecepatan adaptasi background. Rendah = stabil, Tinggi = cepat beradaptasi.", -1))
            ]),
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("label", _hoisted_182, [
                _cache[182] || (_cache[182] = _createTextVNode("Morphology Kernel Size ", -1)),
                _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.config.morphology_kernel_size), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "11",
                step: "2",
                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.config.morphology_kernel_size) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.morphology_kernel_size,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[183] || (_cache[183] = _createElementVNode("div", { class: "text-muted fs-8 mt-1" }, "Ukuran kernel erosi/dilasi (harus ganjil).", -1))
            ]),
            _createElementVNode("div", _hoisted_184, [
              _createElementVNode("label", _hoisted_185, [
                _cache[184] || (_cache[184] = _createTextVNode("Morph Close Kernel Size ", -1)),
                _createElementVNode("span", _hoisted_186, _toDisplayString(_ctx.config.morph_close_kernel_size), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "21",
                step: "2",
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.config.morph_close_kernel_size) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.morph_close_kernel_size,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_187, [
              _createElementVNode("label", _hoisted_188, [
                _cache[185] || (_cache[185] = _createTextVNode("Frame Difference Threshold ", -1)),
                _createElementVNode("span", _hoisted_189, _toDisplayString(_ctx.config.frame_difference_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "5",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.config.frame_difference_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.frame_difference_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_190, [
              _createElementVNode("label", _hoisted_191, [
                _cache[186] || (_cache[186] = _createTextVNode("Motion History Frames ", -1)),
                _createElementVNode("span", _hoisted_192, _toDisplayString(_ctx.config.motion_history_frames), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "1",
                max: "20",
                step: "1",
                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.config.motion_history_frames) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.motion_history_frames,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_193, [
              _createElementVNode("label", _hoisted_194, [
                _cache[187] || (_cache[187] = _createTextVNode("NMS IoU Threshold (Contour) ", -1)),
                _createElementVNode("span", _hoisted_195, _toDisplayString(_ctx.config.nms_iou_threshold), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "0.01",
                max: "0.5",
                step: "0.01",
                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.config.nms_iou_threshold) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.nms_iou_threshold,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_196, [
              _createElementVNode("label", _hoisted_197, [
                _cache[188] || (_cache[188] = _createTextVNode("NMS Merge Distance (px) ", -1)),
                _createElementVNode("span", _hoisted_198, _toDisplayString(_ctx.config.nms_merge_distance), 1)
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                class: "form-range",
                min: "5",
                max: "100",
                step: "5",
                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.config.nms_merge_distance) = $event))
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.config.nms_merge_distance,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.activeTab === 'background']
        ])
      ])
    ]),
    (_ctx.savedToast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [...(_cache[189] || (_cache[189] = [
          _createElementVNode("div", { class: "toast show align-items-center text-white bg-success border-0" }, [
            _createElementVNode("div", { class: "d-flex" }, [
              _createElementVNode("div", { class: "toast-body" }, [
                _createElementVNode("i", { class: "bi bi-check-circle me-2" }),
                _createTextVNode(" Pengaturan berhasil disimpan! ")
              ])
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.errorToast)
      ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
          _createElementVNode("div", _hoisted_201, [
            _createElementVNode("div", _hoisted_202, [
              _createElementVNode("div", _hoisted_203, [
                _cache[190] || (_cache[190] = _createElementVNode("i", { class: "bi bi-exclamation-circle me-2" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.errorToast), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}